<template>
  <v-app id="app_root">
    <header-navigator />
    <v-content>
      <router-view />
      <small class="copy">&copy; {{ new Date().getFullYear() }} emoooo</small>
    </v-content>
    <footer-navigator />
  </v-app>
</template>

<script>
import HeaderNavigator from "@/components/HeaderNavigator.vue";
import FooterNavigator from "@/components/FooterNavigator.vue";

export default {
  name: "App",
  components: {
    HeaderNavigator,
    FooterNavigator
  },
  mounted() {
    this.$store.commit("setFullScreenFlg", false);
  }
};
</script>

<style lang="scss">
#app_root {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  background: #ffffff;
}

.copy {
  display: block;
  margin-bottom: 8px;
  color: #aaa;
  font-size: 0.857rem;
  text-align: center;
  text-decoration: none;
}
</style>
